<h2 mat-dialog-title>{{ "TERMS_OF_USE.TITLE" | translate }}</h2>
<mat-dialog-content class="mat-typography">
    <p [innerHTML]="termsOfUse | safeHTML"></p>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button [id]="'button_CloseTerms'" mat-button mat-dialog-close>
        {{ "TERMS_OF_USE.BUTTON_LABEL" | translate }}
    </button>
</mat-dialog-actions>
